"use client";

import { useLocale } from "@i18n/react";

import { dateFormatYYYYMMDD } from "../../../../../../lib/utils/dates/dateFormatYYYYMMDD";
import type {
  GetParameters,
  UseOpenApiQueryOptions,
} from "../../../../../../request/hooks/openApi/useOpenApiQuery";
import { useOpenApiQuery } from "../../../../../../request/hooks/openApi/useOpenApiQuery";
import { keyCommunitiesStatsTimeGraph } from "./keyCommunitiesStatsTimeGraph";

const urlBackendPath = "/communities/{community_id}/stats/time-graph" as const;

export type CommunitiesStatsTimeGraphType = NonNullable<
  NonNullable<GetParameters<typeof urlBackendPath>["query"]>["type"]
>;

export type UseRequestCommunitiesStatsTimeGraphProps = Omit<
  UseOpenApiQueryOptions<typeof urlBackendPath>,
  "urlBackendPath" | "params" | "queryKey"
> & {
  endDate?: Date;
  id: number;
  startDate?: Date;
  type: CommunitiesStatsTimeGraphType;
};

export const useRequestCommunitiesStatsTimeGraph = ({
  endDate,
  id,
  startDate,
  type,
  ...props
}: UseRequestCommunitiesStatsTimeGraphProps) => {
  /* The response labels are localized by the backend, so the locale is part of the key. */
  const locale = useLocale();

  return {
    query: useOpenApiQuery({
      ...props,
      urlBackendPath,
      params: {
        path: { community_id: id },
        query: {
          type,
          ...(startDate
            ? { start_date: dateFormatYYYYMMDD({ date: startDate }) }
            : {}),
          ...(endDate
            ? { end_date: dateFormatYYYYMMDD({ date: endDate }) }
            : {}),
        },
      },
      queryKey: [
        ...keyCommunitiesStatsTimeGraph({ endDate, id, startDate, type }),
        locale,
      ],
    }),
  };
};
